// extracted by mini-css-extract-plugin
export default {"brass-tab-container":"BottomDetailsViewer_brass-tab-container__-n7gQ","list-view":"BottomDetailsViewer_list-view__E1G3i"};